const palettes = [
    [
      // https://coolors.co/f3a32f-1c3569-f8f9fa-25ced1-177e89
      '#F3A32F',
      '#1C3569',
      '#F8F9FA',
      '#25CED1',
      '#177E89'
    ],
    [
      // https://coolors.co/ceb43d-f2d59d-54998d-336c7f-193266
      '#CEB43D',
      '#F2D59D',
      '#54998D',
      '#336C7F',
      '#193266'
    ],
    [
      // https://coolors.co/app/f8ffe5-1b9aaa-ef476f-ffc43d-32e875
      '#F8FFE5',
      '#1B9AAA',
      '#EF476F',
      '#FFC43D',
      '#32E875'
    ],
    [
      // https://coolors.co/540d6e-ee4266-ffd23f-3bceac-0ead69
      '#540d6e',
      '#ee4266',
      '#ffd23f',
      '#3bceac',
      '#0ead69'
    ],
    [
      // https://coolors.co/231942-5e548e-9f86c0-be95c4-e0b1cb
      '#231942',
      '#5e548e',
      '#9f86c0',
      '#be95c4',
      '#e0b1cb'
    ],
    [
      // https://coolors.co/app/270722-e01a4f-f3b61f-f7d488-d3fad6
      '#270722',
      '#e01a4f',
      '#f3b61f',
      '#f7d488',
      '#d3fad6'
    ],
    [
      // https://coolors.co/app/0077bb-e5f9e0-a3f7b5-40c9a2-664147
      '#0077bb',
      '#e5f9e0',
      '#a3f7b5',
      '#40c9a2',
      '#664147'
    ],
    [
      // https://coolors.co/006e90-70cad1-d7fdec-a9fbd7-73eedc
      '#006e90',
      '#70cad1',
      '#d7fdec',
      '#a9fbd7',
      '#73eedc'
    ],
    [
      // https://coolors.co/app/f5f4f2-feedf3-feb4c1-cd3c67-3f3f3f
      '#F5F4F2',
      '#feedf3',
      '#feb4c1',
      '#cd3c67',
      '#3f3f3f'
    ],
    [
      // https://coolors.co/f7bb93-dc846e-e9dbd4-ebc2b6-f8f1e2
      '#f7bb93',
      '#dc846e',
      '#e9dbd4',
      '#ebc2b6',
      '#f8f1e2'
    ],
    [
      // https://coolors.co/app/003049-d62828-f77f00-fcbf49-eae2b7
      '#003049',
      '#d62828',
      '#f77f00',
      '#fcbf49',
      '#eae2b7'
    ],
    [
      // https://coolors.co/app/bce784-5dd39e-348aa7-525174-513b56
      '#bce784',
      '#5dd39e',
      '#348aa7',
      '#525174',
      '#513b56'
    ],
    [
      // https://coolors.co/app/000000-2f4550-586f7c-b8dbd9-f4f4f9
      '#000000',
      '#2f4550',
      '#586f7c',
      '#b8dbd9',
      '#f4f4f9'
    ],
    [
      // https://coolors.co/app/040f0f-248232-2ba84a-2d3a3a-fcfffc
      '#040f0f',
      '#248232',
      '#2ba84a',
      '#2d3a3a',
      '#fcfffc'
    ],
    [
      // https://coolors.co/1a535c-4ecdc4-f7fff7-ff6b6b-ffe66d
      '#1a535c',
      '#4ecdc4',
      '#f7fff7',
      '#ff6b6b',
      '#ffe66d'
    ],
    [
      // https://coolors.co/05668d-427aa1-ebf2fa-679436-a5be00
      '#05668d',
      '#427aa1',
      '#ebf2fa',
      '#679436',
      '#a5be00'
    ],
    [
      // https://coolors.co/000000-5d737e-fff07c-f0f7ee-87bba2
      '#000000',
      '#5d737e',
      '#fff07c',
      '#f0f7ee',
      '#87bba2'
    ],
    [
      // https://coolors.co/app/00467f-00072d-008ecd-a6e1fa-00072d
      '#00467f',
      '#00072d',
      '#008ecd',
      '#a6e1fa',
      '#00072d'
    ],
    [
      // https://coolors.co/app/fff75a-fffd98-8693ab-96adc8-c4cad0
      '#fff75a',
      '#fffd98',
      '#8693ab',
      '#96adc8',
      '#c4cad0'
    ],
    [
      // https://coolors.co/app/447604-85cb33-9ffcdf-52ad9c-3c1b43
      '#447604',
      '#85cb33',
      '#9ffcdf',
      '#52ad9c',
      '#3c1b43'
    ],
    [
      // https://coolors.co/app/215a72-3e95ad-f5ee9e-f49e4c-ab3428
      '#215a72',
      '#3e95ad',
      '#f5ee9e',
      '#f49e4c',
      '#ab3428'
    ],
    [
      // https://coolors.co/app/a8f9ff-ffffff-56cbf9-ffe74c-ff729f
      '#a8f9ff',
      '#ffffff',
      '#56cbf9',
      '#ffe74c',
      '#ff729f'
    ],
    [
      // https://coolors.co/app/f2dd6e-f2a359-e5b25d-b87d4b-523a34
      '#f2dd6e',
      '#f2a359',
      '#e5b25d',
      '#b87d4b',
      '#523a34'
    ],
    [
      // https://coolors.co/palette/f72585-7209b7-3a0ca3-4361ee-4cc9f0
      '#F72585',
      '#7209B7',
      '#3A0CA3',
      '#4361EE',
      '#4CC9F0'
    ],
    [
      // https://coolors.co/palette/001524-15616d-ffecd1-ff7d00-78290f
      '#001524',
      '#15616D',
      '#FFECD1',
      '#FF7D00',
      '#78290F'
    ],
    [
      // https://coolors.co/palette/ffffff-84dcc6-a5ffd6-ffa69e-ff686b
      '#FFFFFF',
      '#84DCC6',
      '#A5FFD6',
      '#FFA69E',
      '#FF686B'
    ],
    [
      // https://coolors.co/palette/0b3954-087e8b-bfd7ea-ff5a5f-c81d25
      '#0B3954',
      '#087E8B',
      '#BFD7EA',
      '#FF5A5F',
      '#C81D25'
    ],
    [
      // https://coolors.co/palette/f5e6e8-d5c6e0-aaa1c8-967aa1-192a51
      '#F5E6E8',
      '#D5C6E0',
      '#AAA1C8',
      '#967AA1',
      '#192A51'
    ]
  ];

  export default palettes;